import React from 'react';
import styles from './logo.module.scss';
import { routes } from 'src/routes';

const Logo = ({ sticky }: { sticky?: boolean }) => (
  <a href={routes.index()} className={[styles.logo, sticky && styles.sticky].join(' ')} />
);

export default Logo;
